// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Notifications_wrapper__15Dw_","notifType":"Notifications_notifType__2vkRs","list":"Notifications_list__5ZG6X","title":"Notifications_title__9abvM"};